export const formatTimeDifference = remainingMinutes => {
  let timeDiffString = "";

  switch (true) {
    case remainingMinutes > 0:
      timeDiffString += `${remainingMinutes}`;
      break;

    default:
      timeDiffString = "0";
      break;
  }

  return timeDiffString;
};
